export class FieldToMerge {
    public key!: string
    public value!: string[]
}